export const isOverdue = (date) => date < Date.now();

export const toDate = (dateString) => dateString ? new Date(dateString) : null;
